import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'bp-icon-more-01',
	templateUrl: './icon-more-01.component.svg',
})
export class IconMore01Component {}
